import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './shell/Sidebar'
import { Topbar } from './shell/Topbar'
import { CommandProvider } from './command'
import { SourceViewerProvider } from './source-viewer'

export function AppLayout() {
  const [navOpen, setNavOpen] = useState(false)
  const loc = useLocation()
  useEffect(() => setNavOpen(false), [loc.pathname]) // close the drawer on navigation

  return (
    <CommandProvider>
    <SourceViewerProvider>
      <div className="grid h-screen grid-cols-[236px_1fr] overflow-hidden max-md:grid-cols-1">
        <div className="max-md:hidden">
          <Sidebar />
        </div>
        <div className="flex min-w-0 flex-col overflow-hidden">
          <Topbar onMenu={() => setNavOpen(true)} />
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto px-7 py-6 max-md:px-4">
            <Outlet />
          </main>
        </div>
      </div>

      {navOpen && (
        <div className="fixed inset-0 z-50 md:hidden" onClick={() => setNavOpen(false)}>
          <div className="absolute inset-0 bg-black/50" />
          <div className="absolute inset-y-0 left-0 w-[264px]" onClick={(e) => e.stopPropagation()}>
            <Sidebar />
          </div>
        </div>
      )}
    </SourceViewerProvider>
    </CommandProvider>
  )
}
